import { FC, ReactElement } from "react";
import { Card, Grid, Stack, Typography } from "@mui/material";
import { formatNumberWithSuffix } from "@/utils";

interface IMetricsCardProps {
  metrics: {
    entryLines: number;
    ports: number;
    weeks: number;
    oldEntrySummaries: number;
    newEntrySummaries: number;
  };
}

const MetricsCard: FC<IMetricsCardProps> = ({ metrics }): ReactElement => {
  const metricsData = [
    { title: "Entry Lines", value: formatNumberWithSuffix(metrics.entryLines) },
    { title: "Ports", value: metrics.ports },
    { title: "Weeks", value: metrics.weeks },
    { 
      title: "Entry Summaries", 
      value: `${metrics.oldEntrySummaries} → ${metrics.newEntrySummaries}`,
      isEntrySummaries: true 
    }
  ];

  return (
    <Card sx={{ p: 3, height: "100%" }}>
      <Stack height="100%" justifyContent="space-between">
        <Typography
          variant="body1"
          fontFamily="Manrope"
          fontWeight={800}
          color="black"
          fontSize="16px"
        >
          FTZ Metrics
        </Typography>
        <Grid container spacing={1.5}>
          {metricsData.map(({ title, value, isEntrySummaries }, index) => (
            <Grid item xs={6} key={index}>
              <Stack
                width="100%"
                height="100%"
                borderRadius="6px"
                p={1.5}
                sx={{
                  backgroundColor: "#0B494B1A",
                }}
              >
                <Typography
                  variant="caption"
                  fontFamily="Manrope"
                  fontWeight={600}
                  color="neutral.500"
                >
                  {title}
                </Typography>
                <Typography
                  variant="h3"
                  fontSize={isEntrySummaries ? 20 : 24}
                  fontWeight={700}
                  color="#2E2C34"
                  fontFamily="Plus Jakarta Sans"
                >
                  {value}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Card>
  );
};

export default MetricsCard; 